import React from "react";
import { useForm } from "react-hook-form";
import { InserirEtapaController } from "../../../../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import { IEtapa } from "../../../../../../../../../Interfaces/Geral/Etapas/EtapasInterfaces";

interface ICadastrarEtapaProps {
    setShow: (show: boolean) => void;
    updateList: () => void;
    ID_CATEGORIA_ATENDIMENTO_TIPO_CASO: number;
}

export default function CadastrarEtapa(props: ICadastrarEtapaProps) {
    const { register, handleSubmit, formState, reset } = useForm<IEtapa>();

    const onSubmit = (formData: IEtapa) => {
        InserirEtapaController({
            ...formData,
            ID_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                props.ID_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        })
            .then(() => props.setShow(false))
            .then(() => reset)
            .then(props.updateList);
    };

    return (
        <>
            <div className="text-center mb-10">
                <h2 className="font-weight-bold">Cadastro de Etapa</h2>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group border-bottom py-3 b-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors
                                .DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO &&
                            "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome da Etapa"
                        name="DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                        ref={register({
                            required: "Insira o nome da etapa",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors
                            .DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            ? formState.errors
                                  .DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                  .message
                            : ""}
                    </div>
                </div>
                <div className="form-group border-bottom py-3 b-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.NR_SLO && "is-invalid"
                        }`}
                        type="number"
                        placeholder="SLO (em horas) "
                        name="NR_SLO"
                        ref={register({
                            min: 0,
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_SLO
                            ? formState.errors.NR_SLO.message
                            : ""}
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
